import React from 'react';
import { MarkdownPreview } from '../components/markdown-preview/MarkdownPreview';
import '../components/markdown-preview/MarkdownPreview.css';

export const MarkdownPreviewPage: React.FC = () => {
  return (
    <div className="page-container">
      <MarkdownPreview />
    </div>
  );
};
